import { render, staticRenderFns } from "./InputDate.vue?vue&type=template&id=48f6a449&scoped=true&"
import script from "./InputDate.vue?vue&type=script&lang=ts&"
export * from "./InputDate.vue?vue&type=script&lang=ts&"
import style0 from "./InputDate.vue?vue&type=style&index=0&id=48f6a449&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f6a449",
  null
  
)

export default component.exports